// Patient names from upstream sources are inconsistent: X12 ERAs ship
// names UPPERCASE, PracticeBetter ships them mostly Title Case, CSV
// imports preserve whatever was typed. Atlas displays them Title-Cased
// so the same patient reads the same way on every page.
//
// Tolerates "Last, First" by splitting on the comma first. Hyphens are
// preserved as separators so "anne-marie" → "Anne-Marie".

export function formatPatientName(raw) {
  if (!raw) return '—';

  const titleCase = (part) =>
    part
      .toLowerCase()
      .split(/(\s+|-)/)
      .map((token) => {
        if (!token.trim() || token === '-') return token;
        return token.charAt(0).toUpperCase() + token.slice(1);
      })
      .join('');

  if (raw.includes(',')) {
    const [last, first] = raw.split(',', 2).map((s) => s.trim());
    return `${titleCase(last)}, ${titleCase(first || '')}`.replace(/, $/, '');
  }
  return titleCase(raw);
}
